import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

// The items an inactive entity's kebab renders: everything else sits inside the active-only
// block. Holding any one of these is enough for the menu to have something usable in it.
export const INACTIVE_ENTITY_MENU_REQUIRED_ONE_OF_FEATURES = [
    RbacFeature.dashboardActivateDeactivateEntity,
    RbacFeature.dashboardViewSubmissionHistory,
    RbacFeature.dashboardUploadEntityDocument,
    RbacFeature.entityNoteCreate,
];
